import React from 'react';
import { Link } from 'react-router-dom';
import { TOOLS } from 'config/tools';

export default function ToolsGrid() {
    return (
        <div className='mb-8'>
            <h2 className='text-xl font-medium text-black/80 mb-4'>Strumenti</h2>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                {TOOLS.map((tool) => {
                    const Icon = tool.icon;
                    return (
                        <Link
                            key={tool.id}
                            to={tool.path}
                            className={`flex flex-col p-6 bg-white border ${tool.borderColor} rounded-lg hover:shadow-md transition-all duration-200 text-left group`}
                        >
                            <div className={`flex items-center gap-3 mb-3`}>
                                <div className={`p-3 ${tool.bgColor} rounded-lg group-hover:scale-110 transition-transform duration-200`}>
                                    <Icon size={24} className={tool.color} />
                                </div>
                                <h3 className='text-lg font-semibold text-black/80'>{tool.name}</h3>
                            </div>
                            <p className='text-sm text-black/60 leading-relaxed'>{tool.description}</p>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
